export enum UserStatus {
  ACTIVE = 1,
  SUBMIT_REVIEW,
  WAITING_REVIEW,
  INACTIVE = 4,
}
